<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrowdown`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.59142 6.02791C5.33172 5.76821 4.90971 5.76821 4.65001 6.02791C4.39083 6.28749 4.39087 6.70873 4.65001 6.96834L5.59142 6.02791ZM11.3492 6.96834C11.6086 6.70863 11.6088 6.2875 11.3492 6.02791C11.0896 5.76837 10.6685 5.76856 10.4088 6.02791L11.3492 6.96834ZM7.31701 9.63533C7.67026 9.98854 8.22999 10.0107 8.609 9.70174L8.68224 9.63533L11.3492 6.96834L10.8785 6.49861L10.4088 6.02791L7.99962 8.43709L5.59142 6.02791L5.12072 6.49861L4.65001 6.96834L7.31701 9.63533Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowdown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
